import React from 'react';

interface TableSkeletonProps {
  columns: number;
  rows: number;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({ columns, rows }) => {
  return (
    <div className="rounded-xl overflow-hidden bg-white shadow-lg animate-pulse">
      <div className="overflow-x-auto relative">
        <table className="min-w-full table-auto border-collapse">
          <thead>
            <tr className="text-center bg-gradient-to-r from-[#02385E] to-[#02385E]/90">
              {Array(columns).fill(0).map((_, index) => (
                <th 
                  key={index}
                  className="px-4 py-3 text-left whitespace-nowrap border-r border-[#ffffff20]"
                >
                  <div className="h-4 bg-white/20 rounded w-24"></div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {Array(rows).fill(0).map((_, rowIndex) => (
              <tr 
                key={rowIndex}
                className={rowIndex % 2 === 0 ? 'bg-white' : 'bg-slate-50'}
              >
                {Array(columns).fill(0).map((_, colIndex) => (
                  <td 
                    key={colIndex}
                    className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100"
                  >
                    {colIndex === 0 ? (
                      <div className="flex items-center">
                        <div className="h-8 w-8 rounded-full bg-gray-200 mr-2"></div>
                        <div className="flex-1">
                          <div className="h-4 bg-gray-200 rounded w-24 mb-1"></div>
                          <div className="h-3 bg-gray-200 rounded w-32"></div>
                        </div>
                      </div>
                    ) : (
                      <div className="flex justify-center">
                        <div className="h-6 bg-gray-200 rounded-full w-8"></div>
                      </div>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableSkeleton;
